const STORAGE_KEY = {
	ID_ENTITE_CPTA: 'identifiantEntiteCompta',
	ID_ENTITE: 'identifiantEntite',
} as const;

export default STORAGE_KEY;
